import Typography from '@mui/material/Typography';

export function LibraryEmptySearchResults() {
  return (
    <Typography variant="caption" color="text.secondary">
      No results found.
    </Typography>
  );
}
